import * as $ from 'jquery';

import {
  Inject,
  OnInit,
  Directive,
  Component,
  OnDestroy,
} from 'ng-metadata/core';

import './rotator.scss';

/**
 * Portal rotator directive. Uses a slick directive inside.
 * This is just a container for the config object settings.
 */
@Directive({
  selector: 'gwRotator',
})
export class RotatorDirective implements OnInit, OnDestroy {
  public slickConfig;

  constructor(
    @Inject('$scope') private $scope,
  ) {}

  ngOnInit() {
    this.$scope.currentSlide = 0;
    this.$scope.slickConfig = {
      dots: true,
      method: {},
      currentSlide: 0,
      event: {
        afterChange: (event, slick, currentSlide, nextSlide) => {
          this.$scope.currentSlide = currentSlide; // save current index each time
        },
        init: (event, slick) => {
          if (slick) slick.slickGoTo(this.$scope.currentSlide); // slide to correct index when init
        },
      },
    };

    // I know...
    const $window = $(window);
    const $body = $(document.body);

    $window.on('scroll', (e) => {
      const scrollTop = $window.scrollTop();

      window.requestAnimationFrame(() => {
        if (scrollTop > 100) {
          $body.addClass('is-scrolled');
        } else {
          $body.removeClass('is-scrolled');
        }
      });
    });
  }

  ngOnDestroy() {
    $(window).off('scroll');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/rotator/rotator.component.ts